import { getCoordinates } from '@/api/map';
import { useState, useEffect } from 'react';
import { DateRange } from 'react-day-picker';

export const useMaps = (
  searchTerm: string,
  status: string,
  selectedCollector: string,
  dateRange: DateRange | undefined
) => {
  const [coordinates, setCoordinates] = useState<CollectionOrder[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMaps = async () => {
    setLoading(true);
    try {
      const response: CollectionOrder[] = await getCoordinates({
        searchTerm,
        status,
        selectedCollector,
        dateRange,
      });
      setCoordinates(response);
    } catch (err) {
      setError('Failed to fetch maps');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaps();
  }, [searchTerm, status, selectedCollector, dateRange]);

  const refresh = () => {
    fetchMaps();
  };

  return { coordinates, refresh, loading, error };
};
